import { connect } from 'react-redux';
import LoginForm from '../LoginForm/LoginForm';
import {
  isApplePhoneSelector,
  isPhoneSelector,
  isDposMode,
  isSelfServiceMode,
  isPaymentKiosk,
  allowPhoneNumberConfigSelector
} from '../../selectors/configSelectors';
import { isUploadInProgressSelector } from '../../selectors/uploadSelectors';
import { isKioskMode as isKioskSelector } from '../../selectors/viewSelectors';
import { signInTreezUser } from "../../actions/login";

const mapStateToProps = (state) => ({
  isPhone: isPhoneSelector(state),
  minLength: 3,
  maxLength: 25,
  isApplePhone: isApplePhoneSelector(state),
  isUploadInProgress: isUploadInProgressSelector(state),
  isKiosk: isKioskSelector(state) || isDposMode(state) || isSelfServiceMode(state) || isPaymentKiosk(state),
  isPaymentKiosk: isPaymentKiosk(state),
  allowLoginPhoneNumber: allowPhoneNumberConfigSelector(state),
  showSignUp: false,
  showShopping: false,
  formTitle: 'PLEASE LOG IN USING TREEZ USER TO AUTHORIZE KIOSK',
  showForgotPassword: false,
  showCloseIcon: false,
  showSignInWithIdScan: false,
  showLoginInputs: true,
  showIdScanError: false,
  isHubConnected: false
});

const mapDispatchToProps = dispatch => ({
  onSubmit: (data) => {
    dispatch(signInTreezUser(
      data.email,
      data.password
    ));
  },
  onCloseRequest: () => { },
  onSignUp: () => { },
  onShopping: () => { },
  openResetPassword: () => { },
  onBeginSignInWithIdScan: () => { },
  onEndSignInWithIdScan: () => { }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginForm);



// WEBPACK FOOTER //
// ./src/components/KioskLoginForm/KioskLoginFormContainer.js